import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_VENDORS, ADD_VENDOR, UPDATE_VENDOR, UPDATE_VENDOR_PAYABLE
} from 'redux/actionTypes';
import { incrementIDGen, setNewPOVendorId } from '.';
import { vendor } from 'variables/idGenType';

export const getVendors = () => (dispatch, getState) => {
  axiosClient
    .get('/api/vendors', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_VENDORS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addVendor = (newVendor, updateNewPO, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/vendors', newVendor, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: vendor }));
      
      //if the vendor is created for a new PurchaseOrder, update the vendorId.
      if(updateNewPO) dispatch(setNewPOVendorId(res.data.id));
      dispatch({
        type: ADD_VENDOR,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateVendor = (updatedVendor) => (dispatch, getState) => {
  axiosClient
    .patch('/api/vendors', updatedVendor, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_VENDOR,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const incrementVendorPayable = (updatedAmount) => (dispatch, getState) => {
  axiosClient
    .patch('/api/vendors/increment', updatedAmount, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_VENDOR_PAYABLE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const decrementVendorPayable = (updatedAmount) => (dispatch, getState) => {
  axiosClient
    .patch('/api/vendors/decrement', updatedAmount, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_VENDOR_PAYABLE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};